module.exports = __webpack_public_path__ + "img/switcher-separator-grey.78c27138.svg";